var map = {
	"./certificate_automatic_frame.png": 156,
	"./certificate_ects_frame.png": 157,
	"./certificate_frame.png": 158,
	"./certificate_verified_frame.png": 159,
	"./frame_blue_de.png": 160,
	"./frame_blue_en.png": 161,
	"./frame_gold_de.png": 162,
	"./frame_gold_en.png": 163,
	"./frame_green_de.png": 164,
	"./frame_green_en.png": 165,
	"./generic_audit_sample.jpg": 166,
	"./generic_bundle_sample.jpg": 167,
	"./generic_coa_ects_sample.jpg": 168,
	"./generic_coa_sample.jpg": 169,
	"./generic_sop_sample.jpg": 170,
	"./milestone_completed.png": 171,
	"./milestone_completed.svg": 172,
	"./milestone_completed_small.svg": 173,
	"./milestone_uncompleted.png": 174,
	"./milestone_uncompleted.svg": 175,
	"./milestone_uncompleted_old.png": 176
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 155;